var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{staticClass:"audio",staticStyle:{"padding":"10px"},attrs:{"controls":"controls","controlsList":"nodownload"}},[_c('source',{attrs:{"src":_vm.src,"type":"audio/ogg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }